<template>
  <div id="app">
  <navbar/>
  <sectionone/>
  <about/>
  <serve/>
  <port/>
  <blog/>
  <contact/>
  </div>
  <router-view/>
</template>
<script>
import navbar from './components/navbar.vue';
import sectionone from './components/sectionone.vue';
import about from './components/abdoutus.vue';
import serve from './components/serves.vue';
import port from './components/portfolio.vue';
import blog from './components/blog.vue';
import contact from './components/contact.vue';
export default {
  name: 'App',
  components: {
    navbar,
    sectionone,
    about,
    serve,
    port,
    blog,
    contact,
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; 
}
</style>
